import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { ListLoadingItemDesktop } from './desktop';
import { ListLoadingItemMobile } from './mobile';
import { ListLoadingItemTablet } from './tablet';

export const ListLoadingItem: React.FC = () => {
  const listLoadingItem = useBreakpointValue({
    base: <ListLoadingItemMobile />,
    sm: <ListLoadingItemTablet />,
    lg: <ListLoadingItemDesktop />,
  });

  return listLoadingItem;
};
